module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Sport Aluminum + Walnut Closed.bc7163d9.png";